import { render } from "./MasterDataTable.vue?vue&type=template&id=4d152914&scoped=true"
import script from "./MasterDataTable.vue?vue&type=script&lang=js"
export * from "./MasterDataTable.vue?vue&type=script&lang=js"

import "./MasterDataTable.vue?vue&type=style&index=0&id=4d152914&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d152914"]])

export default __exports__